import enviro from 'enviro';
import PortalIdParser from 'PortalIdParser';
import { userInfoSync } from 'hub-http/userInfo';
import { prepareLocalSendMessageRpc, prepareLocalSendMessagesRpc, prepareLocalToolResponseRpc, prepareLocalToolApprovalRpc, cancelTurnRpc } from '../../__generated__/chirp/com/hubspot/breeze/engine/rpc/BreezeEngineService';
import { buildBenderProxyUrl, fetchLocalDevStatus, getBenderProxyOrigin } from '../localDev/benderProxy';
export async function getLocalAgentExecution(agentId) {
  if (!enviro.isQa()) {
    return null;
  }
  return getLocalAgentExecutionFromStatus(agentId, await fetchLocalDevStatus());
}
export function getLocalAgentExecutionFromStatus(agentId, status) {
  if (status.localAgentRoutes.some(route => route.agentId === agentId)) {
    return 'custom';
  }
  return status.managedWorkerRunningLocally ? 'managed' : null;
}
export async function postLocalTq2Request(localEnqueuePath, tq2Request) {
  const response = await fetch(buildBenderProxyUrl(localEnqueuePath), {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(tq2Request)
  });
  if (!response.ok) {
    throw new Error(`Local agent enqueue failed with status ${response.status}`);
  }
  if (!getBenderProxyOrigin() && !response.headers.get('x-bender-proxy-target')) {
    throw new Error('Local agent enqueue did not route through bender-proxy');
  }
}
export async function prepareAndEnqueueLocalSendMessage(client, request) {
  const response = await client.call(prepareLocalSendMessageRpc, {
    request
  });
  try {
    await postLocalTq2Request(response.localEnqueuePath, response.tq2Request);
  } catch (error) {
    await client.call(cancelTurnRpc, {
      request: {
        conversationId: response.conversationId,
        turnId: response.turnId
      }
    });
    throw error;
  }
  return response;
}
export async function prepareAndEnqueueLocalSendMessages(client, request) {
  const response = await client.call(prepareLocalSendMessagesRpc, {
    request
  });
  try {
    await postLocalTq2Request(response.localEnqueuePath, response.tq2Request);
  } catch (error) {
    await client.call(cancelTurnRpc, {
      request: {
        conversationId: response.conversationId,
        turnId: response.turnId
      }
    });
    throw error;
  }
  return response;
}
const LOCAL_ABLY_TOKEN_TIMEOUT_MS = 10000;
export async function fetchLocalAblyToken(agentId, channelId) {
  var _userInfo$user;
  if (!enviro.isQa()) {
    throw new Error('fetchLocalAblyToken is only available in QA environments');
  }
  const portalId = PortalIdParser.get();
  const userInfo = userInfoSync();
  const userId = userInfo === null || userInfo === void 0 || (_userInfo$user = userInfo.user) === null || _userInfo$user === void 0 ? void 0 : _userInfo$user.user_id;
  if (userId == null) {
    throw new Error('Cannot fetch local Ably token: user session not loaded');
  }
  const url = buildBenderProxyUrl(`/_breeze-engine/local-agents/${agentId}/ably-token`);
  // eslint-disable-next-line compat/compat
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), LOCAL_ABLY_TOKEN_TIMEOUT_MS);
  const response = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      channelId,
      portalId,
      userId
    }),
    signal: controller.signal
  }).finally(() => clearTimeout(timeoutId));
  if (!response.ok) {
    throw new Error(`Local Ably token request failed with status ${response.status}`);
  }
  const data = await response.json();
  if (typeof (data === null || data === void 0 ? void 0 : data.token) !== 'string' || typeof (data === null || data === void 0 ? void 0 : data.channelId) !== 'string') {
    throw new Error('Local Ably token response missing token or channelId');
  }
  return data;
}
export async function prepareAndEnqueueLocalToolResponse(client, request) {
  const response = await client.call(prepareLocalToolResponseRpc, {
    request
  });
  try {
    await postLocalTq2Request(response.localEnqueuePath, response.tq2Request);
  } catch (error) {
    await client.call(cancelTurnRpc, {
      request: {
        conversationId: request.conversationId,
        turnId: request.turnId
      }
    });
    throw error;
  }
  return response;
}
export async function prepareAndEnqueueLocalToolApproval(client, request) {
  const response = await client.call(prepareLocalToolApprovalRpc, {
    request
  });
  try {
    await postLocalTq2Request(response.localEnqueuePath, response.tq2Request);
  } catch (error) {
    await client.call(cancelTurnRpc, {
      request: {
        conversationId: request.conversationId,
        turnId: request.turnId
      }
    });
    throw error;
  }
  return response;
}